import { Component, OnInit } from '@angular/core';

import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/core/local-storage.service';
import { GlobalVariable } from '../global';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NavController } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';


@Component({
  selector: 'app-slider',
  templateUrl: './slider.page.html',
  styleUrls: ['./slider.page.scss'],
})
export class SliderPage implements OnInit {
  isTrue = true;
  slides=[];
  dataLoaded=false;
  slideOpts: {
    slidesPerView:1,

    // pagination: {
    //   el: '.swiper-pagination',
    //   type: 'custom',

    // },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },

  };
  constructor(
    private sliderShown: UserService,
    
    public router: Router,
    private localStorageService: LocalStorageService,
    public globals:GlobalVariable,
    private location:Geolocation,
    private nav : NavController,
    public server:UserApiService,
    
    ) {
      // ALi Hassan
      this.localStorageService.setTour('Tour', JSON.stringify(true));
      // ALi Hassan
  }
ionViewWillEnter(){
  this.loadSlides();
}
  ngOnInit() {
this.getlocation();
    // this.sliderShown.showSliderOnce(this.isTrue)
    //  window.location.reload();
    // this.storage.set('sliderInfo',this.isTrue).then(resp=>{
    //   console.log(resp)
    // })
  }
  getlocation(){
    this.location.getCurrentPosition().then(res=>{

    },err=>{
      console.log(err)
    })
  }
  terms(){
    this.router.navigate(['terms-conditions']);
  }

  home(){
    // this.nav.navigateRoot('tabs/tabs/home')
    if(this.globals.inWeb){

      this.nav.navigateRoot('/order');
        
      }
      else{
        
        this.nav.navigateRoot('/tabs/tabs/home');
      }
  }

  loadSlides(){
    this.server.welcomeSlides().subscribe(res=>{

      console.log(res)
      if(res.status==true){
  this.dataLoaded=true;

       this.slides= res.banners;
      }
      else{
        this.home();
      }
    },err=>{

      this.home();

    })
  }
}
